// extracted by mini-css-extract-plugin
module.exports = {"label":"i_FY","add-new-tag":"i_FZ"};